import { render, staticRenderFns } from "./fknnTable.vue?vue&type=template&id=fe3e16fc&scoped=true"
import script from "./fknnTable.vue?vue&type=script&lang=ts"
export * from "./fknnTable.vue?vue&type=script&lang=ts"
import style0 from "./fknnTable.vue?vue&type=style&index=0&id=fe3e16fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe3e16fc",
  null
  
)

export default component.exports